/**
 * i18next bootstrap — Sprint 3 T3.2 / SYSTEM-01.
 *
 * Eager-loads all bundled locales (en/ru for MVP) so first paint never
 * shows raw keys. Language detection: localStorage → navigator → "en".
 *
 * Adding a locale = drop a file under `./locales/<code>.json`, register
 * in the resources map below, and add the code to the language switcher
 * in `components/i18n/LanguageSelector.tsx` (Phase 3 once that exists).
 */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ru from "./locales/ru.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ru"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "ui_language",
    },
  });

export default i18n;
